<a [href]="link" class="link">
  @if (name === 'instagram_color') {
    <!-- instagram だけ svg が重いので画像にしている -->
    <img src="assets/icons/brand/instagram.png" alt="instagram" class="image" />
  } @else {
    <tbx-icon [name]="iconName" class="icon"></tbx-icon>
  }
</a>
